import type { SkillSource } from "./index"

/** Wave O1 (decision 0060, wave spec §2.4; practices P6): hand this session's work to Minga before it ends. */
export const handOff: SkillSource = {
  name: "hand-off",
  title: "Hand off this session to Minga",
  description:
    "Hand this session's work to the Minga project before the session ends: summarise what was done and what is left, capture it with the branch and PR link, and tell the lead in one line. Use it when the person says hand off, wrap up, park this, or leave it for the lead.",
  body: `# Hand off this session to Minga

## Steps

1. Find the project: \`read_project\` with \`project\` = the output of \`git remote get-url origin\`. Not found: no project
   has this repo; ask which project (\`list_projects\` shows them).
2. Summarise the session for someone who wasn't there: what was done, what is left, what you were unsure about, the
   branch (\`git branch --show-current\`), the last commit, and the open PR link if there is one. Short; link, don't
   paste.
3. Show the summary to the person and wait for their yes.
4. Write it:
   - one thing left: one \`capture\` with the summary in its \`body\`;
   - several things left: one \`plan\` with \`import: false\` that creates one item per thing (no workers or agents as
     assignees, nothing moved into Now). If the work belongs to an existing item, \`comment\` on it instead.
5. One \`ask_lead\` line: "I handed off <what> (<refs>). Nothing is started; pick it up when it fits the plan."
6. Tell the person the refs.

## Never

- Start work, assign workers or agents, or move anything into Now.
- Leave out what is unfinished or broken.
- Paste a secret's value, customer data or personal data into Minga text (keys go into Settings › Secrets).
`,
}
